export enum DisplayCategory {
	Recharge = 0,
	Esim = 2,
	Pin = 10,
	GiftCard = 11,
	BillPay = 12,
}
export enum Category {
	Topup = 0,
	Bundle = 1,
	Data = 2,
	Esim = 3,
	Pin = 10,
	GiftCard = 11,
	BillPay = 12,
}

export enum GiftCardCategory {
	NotApplicable = 0,
	OnlineShopping = 1,
	Games = 2,
	Utility = 3,
	CashCards = 4,
	Travel = 5,
	Beauty = 6,
	HomeImprovement = 7,
	Restaurant = 8,
	FoodAndBeverage = 9,
	MoviesAndEntertainment = 10,
	GroceryAndPharmacy = 11,
	SportsAndOutdoors = 12,
}

export enum PaymentType {
	CreditCard,
	StoredCreditCard,
	Paypal,
	Zero,
	Voucher
}